module.exports = __webpack_public_path__ + "img/Lumispectrums.c1dc26aa.png";